import { useMutation } from '@tanstack/react-query';
import { POST, POST_CHECK_EMPLOYEE } from '../../../services';

export const useGetEmployee = () => {
  const { mutate } = useMutation({
    mutationFn: async (employeeId) => {
      const payload = {
        employeeId,
      };
      const response = await POST(POST_CHECK_EMPLOYEE(), payload);
      return response;
    },
  });

  return {
    mutate,
  };
};
